// assets/product-favorite.js
// Client-side favorite toggle, no backend/app needed — persisted to
// localStorage as a set of product IDs so the state survives reload.
import { Component } from '@theme/component';

const STORAGE_KEY = 'bobby:favorites';

function readFavorites() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function writeFavorites(set) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch {
    // localStorage unavailable (private mode, quota, etc.) — toggle still
    // works for the current page view, it just won't persist.
  }
}

class ProductFavoriteComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#sync();
    this.refs.favoriteButton?.addEventListener('click', () => this.#toggle());
  }

  #productId() {
    return this.dataset.productId;
  }

  #toggle() {
    const id = this.#productId();
    if (!id) return;
    const favorites = readFavorites();
    if (favorites.has(id)) {
      favorites.delete(id);
    } else {
      favorites.add(id);
    }
    writeFavorites(favorites);
    this.#sync();
  }

  #sync() {
    const id = this.#productId();
    const { favoriteButton, favoriteLabel } = this.refs;
    if (!favoriteButton || !id) return;
    const isSaved = readFavorites().has(id);
    favoriteButton.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    if (favoriteLabel) {
      favoriteLabel.textContent = isSaved
        ? this.dataset.savedLabel || 'Saved'
        : this.dataset.label || favoriteLabel.textContent;
    }
  }
}

if (!customElements.get('product-favorite-component')) {
  customElements.define('product-favorite-component', ProductFavoriteComponent);
}
